// state.js

export default {
    allDevices: [],
    isSearchDevicesDone: false,
    devicesList: [],
    deviceTypeList : [],
    currentDeviceType: {
        name: 'No one selected',
        value: 0,
    },
    currentDevice: {
        name: 'No one selected',
        value: 0,
    },
    showHeaderDeviceFilter: false,
};
